<template>
  <div class="tooltip-container"
       @mouseenter="showTooltip"
       @mouseleave="startHide"
       @click="click">
    <slot name="reference">
      <div class="circle">?</div>
    </slot>
    <div :class="['top-end', 'tooltip', { 'tooltip-visible': isTooltipVisible }]"
         :style="{ width: width + 'px' }" ref="tooltip"
         @mouseenter="cancelHide"
         @mouseleave="startHide">
      <div class="tooltip-content font14 blue" v-html="content"></div>
    </div>
    <div :class="['top-end', 'tooltip-arrow', { 'tooltip-visible': isTooltipVisible }]"
         ref="tooltipArrow"></div>
  </div>
</template>

<script setup>
import {defineProps, ref} from "vue";

defineProps({
  width: {
    type: Number,
    default: 200,
  },
  placement: {
    type:String,
    default: 'top-start',
  },
  trigger: {
    type:String,
    default: 'hover',
  },
  content: {
    type:String,
    default: '',
  },
})
const tooltip = ref(null)
const isTooltipVisible = ref(false)
const tooltipArrow = ref(null)
let hideTimeout = null;
function click(){
  isTooltipVisible.value = !isTooltipVisible.value
}
function showTooltip() {
  isTooltipVisible.value = true
  setTimeout(() => {
    document.body.addEventListener('click', startHide);
  }, 100);
}
function startHide () {
  hideTimeout = setTimeout(() => {
    isTooltipVisible.value = false;
    document.body.removeEventListener('click', startHide);
  }, 100); // Задержка в 100 мс
}
function cancelHide () {
  clearTimeout(hideTimeout);
}
</script>

<style scoped>
.tooltip-container {
  position: relative;
}

.tooltip {
  position: absolute;
  bottom: 149%;
  background-color: #fff;
  border: 1px solid #3A5A8F;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  text-wrap: auto;
  display: none;
}
.tooltip-arrow {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #fff;
  border-bottom: 1px solid #3A5A8F;
  border-right: 1px solid #3A5A8F;
  display: none;
}
.top-end.tooltip-arrow {
  transform: translateX(-50%) translateY(calc(100% + 1px)) rotate(45deg);
  left: 50%;
  top: -100%
}
.top-end.tooltip {
  transform: translateX(-100%);
  left: 100%;
}
.tooltip-visible {
  display: block;
}
</style>